// extracted by mini-css-extract-plugin
module.exports = {"image":"banner_image__4tSaR"};